<span>
  <ng-content></ng-content>
</span>
